import React from "react";

const Loader = ({ label = "Loading...", className = "" }) => (
  <div className={`font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 ${className}`} data-testid="loader">
    {label}
  </div>
);

export default Loader;
